import React, { useEffect, useState } from 'react'
import { Card, Button, Table, Select, Space, Pagination, Checkbox, message, Tag } from 'antd'
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet';
import { getClueHouseUserList2API, addCustomerAPI, addPreSelectionAPI, getAccountInfoAPI, addAllCustomerAPI } from '@/apis/user'
import { getHouseTreeData2API } from '@/apis/house'
import { checkMenu, checkLogin, checkButton } from '@/utils'
import Dayjs from 'dayjs'
const { Column } = Table

export default function ClueHouseUserList() {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  console.log('%c [ params ]-15', 'font-size:13px; background:pink; color:#bf2c9f;', params)
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  const houseName = params.name
  const houseId = Number(params.id)
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    houseId: houseId,
    keywords: '',
    isFilterPeers: 0,// 是否过滤同行；0：否；1：是
    isCustomer: null, //	是否加客资，-1：全部；0：否；1：是
    hasPhone: 0, //	是否有电话，0：全部；1：有电话的
    sortStatus: 0, //  排序，0：最新访问时间倒序；1：7日有效访问高低排序；2：30天有效访问高低排序
    rivalHouseId: [],
    intentionRank: 0,
    pageInt: 1,
    pageSize: 10
  })
  const [total, setTotal] = useState(0) //  列表总数
  //  获取线索楼盘列表
  const [list, setList] = useState()
  const [accountInfo, setAccountInfo] = useState({})
  const [rivalHouseList, setRivalHouseList] = useState([])

  //  获取账号详情
  const getAccountInfo = async () => {
    const res = await getAccountInfoAPI()
    if (res.success === true) {
      setAccountInfo(res.result)
    }
  }
  //  竞品楼盘列表
  const getHouseTreeData = async () => {
    const res = await getHouseTreeData2API({ houseid: listQuery.houseId, num: 3 })
    if (res.success === true && res.result) {
      let relatedList = res.result.relatedList ? res.result.relatedList.slice(0, 3) : []
      relatedList?.forEach(item => {
        item.rate = res.result.viewNum ? Math.round((item.viewNum / res.result.viewNum) * 100) + '%' : '0%'
      })
      setRivalHouseList(relatedList)
    }
  }
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }

  //  获取用户列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    const nowTime = new Date().getTime()
    const today = new Date(Dayjs().format('YYYY-MM-DD')).getTime()
    listQuery.isCustomer = listQuery.isCustomer === null ? -1 : listQuery.isCustomer
    setListLoading(true)
    const res = await getClueHouseUserList2API(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.key = index
          item.loading = false
          item.preSelectionLoading = false
          if (item.nickName) {
            item.nickName = decodeURIComponent(item.nickName)
          } else {
            item.nickName = '暂无昵称' + item.userId.toString().slice(-4)
          }
          item.isNewStatus = 0
          if (Dayjs(item.firstVisitTime).unix() * 1000 > today) {
            item.isNewStatus = 1
          } else if (Dayjs(item.firstVisitTime).unix() * 1000 + 7 * 86400000 >= nowTime) {
            item.isNewStatus = 2
          }
          item.hasPhone_text = item.hasPhone ? '有' : '暂无电话'
          item.firstVisitTime = Dayjs(item.firstVisitTime).format('YYYY-MM-DD')
          item.newVisitTime = Dayjs(item.newVisitTime).format('YYYY-MM-DD')
          if(item.intentionHouseList && item.intentionHouseList.length > 0) {
            item.intentionHouseList.forEach(ele => {
              ele.intentionRate = Math.round(ele.intentionRate * 1000) / 10
            })
          }
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  //  过滤已加客资筛选
  const changeIsCustomer = async e => {
    let isCustomer = e.target.checked === true ? 0 : undefined
    if (isCustomer === listQuery.isCustomer) return
    listQuery.isCustomer = isCustomer
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  //  是否过滤同行
  const changeFilterPeers = async e => {
    let isFilterPeers = e.target.checked === true ? 1 : 0
    if (isFilterPeers === listQuery.isFilterPeers) return
    listQuery.isFilterPeers = isFilterPeers
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  //  是否有电话筛选
  const changeHasPhone = async e => {
    let hasPhone = e.target.checked === true ? 1 : 0
    if (hasPhone === listQuery.hasPhone) return
    listQuery.hasPhone = hasPhone
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  const changeSortStatus = async e => {
    if (e === listQuery.sortStatus) return
    listQuery.sortStatus = e
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  const changeIntentionHouse = async e => {
    console.log('%c [ e ]-140', 'font-size:13px; background:pink; color:#bf2c9f;', e)
    if (e === listQuery.intentionRank) {
      listQuery.intentionRank = 0
    } else {
      listQuery.intentionRank = e
      listQuery.rivalHouseId = []
    }
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  //  竞品楼盘筛选
  const changeRivalHouse = async e => {
    console.log('%c [ e ]-138', 'font-size:13px; background:pink; color:#bf2c9f;', e)
    let index = listQuery.rivalHouseId.indexOf(e)
    if(index >= 0) {
      listQuery.rivalHouseId.splice(index, 1)
    } else {
      listQuery.rivalHouseId.push(e)
    }
    if(listQuery.rivalHouseId.length > 0) {
      listQuery.intentionRank = 0
    }
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  const addCustomer = async (row) => {
    list[row.key].loading = true
    setList([...list])
    let isCustomer = row.isCustomer && row.isCustomer === 1 ? 0 : 1
    let params = {
      userId: row.userId,
      isCustomer,
      houseId: houseId
    }
    const res = await addCustomerAPI(params)
    list[row.key].loading = false
    if (res.success === true) {
      message.success('加客资成功')
      list[row.key].isCustomerStatus = 1
      setList([...list])
      //fetchData()
    } else {
      message.error(res.message)
      setList([...list])
    }
  }
  //  预选
  const addPreSelection = async (row) => {
    list[row.key].preSelectionLoading = true
    setList([...list])
    let isPreSelection = row.isPreSelection === true ? 0 : 1
    let params = {
      userId: row.userId,
      isPreSelection,
      houseId: houseId
    }
    const res = await addPreSelectionAPI(params)
    if (res.success === true) {
      message.success((isPreSelection === 1 ? '预选' : '取消预选') + '成功')
      fetchData()
    } else {
      message.error(res.message)
      list[row.key].preSelectionLoading = false
      setList([...list])
    }
  }
  //  批量添加客资
  const addAllCustomer = async () => {
    let params = {
      houseId: houseId
    }
    const res = await addAllCustomerAPI(params)
    if (res.success === true) {
      message.success('成功添加' + res.result.batchNum + '组，消耗余额' + res.result.totalFee + '元，请前往“我的客资”菜单查看')
      fetchData()
    } else {
      message.error(res.message)
    }
  }

  useEffect(() => {
    let path = decodeURIComponent(location.pathname).replace('/' + params.id, '').replace('/' + params.name, '')
    if(!checkMenu(path)) {
      navigate('/managecenter/404')
      return
    }
    getAccountInfo()
    getHouseTreeData()
    fetchData()
  }, [])

  return (
    <div>
      <Helmet>
        <title>{'客资明细-' + process.env.REACT_APP_HTML_TITLE}</title>
      </Helmet>
      <div className='bg-white line-height-76 padding-left-32 padding-right-32 flex-between'>
        <div className='font-size24 font-weight-500'>{houseName}-客资明细</div>
        <div>账户余额：{accountInfo.balance}元{accountInfo.balance < 1000 ? <span className='margin-left-10 red'>（余额不足）</span> : ''}</div>
      </div>
      <Card className="card">
        <div className="flex-between margin-bottom-24">
          <div className="searchForm">
            <Checkbox onChange={changeIsCustomer}>过滤已加客资</Checkbox>
            <Checkbox onChange={changeFilterPeers}>过滤同行</Checkbox>
            <Checkbox onChange={changeHasPhone}>只看有电话</Checkbox>
          </div>
          <div>
            {checkButton('clueuserlist.addalluser') && (
              <Button type="primary" className="searchBtn" style={{ marginRight: '10px' }} onClick={() => addAllCustomer()}>批量添加客资</Button>
            )}
            <Select
              defaultValue={listQuery.sortStatus}
              style={{ width: 240 }}
              onChange={changeSortStatus}
              options={[
                { value: 0, label: '最新访问时间倒序' },
                { value: 1, label: '7日有效访问高低排序' },
                { value: 2, label: '30天有效访问高低排序' }
              ]}
            />
          </div>
        </div>
        <div className='flex align-items padding-top-10 padding-bottom-10 padding-left-20 padding-right-20 line-height-24 bg-f5f6f9 margin-bottom-12 border-radius-4'>
          {checkButton('clueuserlist.intensearch') && (
            <div className='flex align-items'>
              <div className='font-weight'>意向精选：</div>
              <div className='flex-1 flex align-items'>
                <div className='margin-right-24'>
                  <Checkbox checked={listQuery.intentionRank === 1} onChange={() => changeIntentionHouse(1)}>第一意向</Checkbox>
                </div>
                <div className='margin-right-24'>
                  <Checkbox checked={listQuery.intentionRank === 2} onChange={() => changeIntentionHouse(2)}>第二意向</Checkbox>
                </div>
                <div className='margin-right-24'>
                  <Checkbox checked={listQuery.intentionRank === 3} onChange={() => changeIntentionHouse(3)}>第三意向</Checkbox>
                </div>
              </div>
            </div>
          )}
          {checkButton('clueuserlist.rivalsearch') && (
            <div className='flex align-items'>
              <div className='font-weight'>使用竞品精选客资：</div>
              <div className='flex-1 flex align-items'>
                {rivalHouseList.map((item, index) => {
                  return (
                    <div className='margin-right-24' key={index}>
                      <Checkbox checked={listQuery.rivalHouseId.includes(item.houseId)} onChange={() => changeRivalHouse(item.houseId)}>{item.houseName} / {item.rate}</Checkbox>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </div>
        
        
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column
            title="昵称"
            key="nickName"
            render={(_, record) => (
              <Space size="middle">
                {record.nickName}
                {record.isLandlord ? <div className="purple">业主</div> : ''}
                {record.isNewStatus == 1 ? <div className="red">今日首访</div> : record.isNewStatus == 2 ? <div className="green">新客</div> : ''}
              </Space>
            )}
          />
          <Column
            title="标签"
            key="labelList"
            render={(_, record) => (
              record.labelList && record.labelList.map((item, index) => {
                return (
                  <div key={index} className='margin-top-12'>
                    <Tag>{item.tagName}</Tag>
                  </div>
                )
              })
            )}
          />
          <Column
            title="近期意向楼盘"
            key="intentionHouseList"
            render={(_, record) => (
              record.intentionHouseList && record.intentionHouseList.map((item, index) => {
                return (
                  <div key={index} className='margin-top-12'>
                    <div>{item.houseName}({item.intentionRate}%)</div>
                  </div>
                )
              })
            )}
          />
          <Column title="有无电话" dataIndex="hasPhone_text" />
          <Column title="7日有效访问" dataIndex="weekVisitorNum" />
          <Column title="30天" dataIndex="monthVisitorNum" />
          <Column title="90天" dataIndex="quarterVisitorNum" />
          <Column title="180天" dataIndex="halfYearVisitorNum" />
          <Column title="首次访问" dataIndex="firstVisitTime" />
          <Column title="最近访问" dataIndex="newVisitTime" />
          <Column
            title="操作"
            key="action"
            fixed="end"
            width={170}
            render={(_, record) => (
              <Space size={0}>
                <Link target="_blank" to={'/managecenter/user/detail/' + record.userId} className="color-576b95">
                  画像
                </Link>
                {(checkButton('clueuserlist.preselection') && record.hasPhone) && <Button type="link" loading={record.preSelectionLoading} onClick={() => addPreSelection(record)} className="color-576b95">{record.isPreSelection == true ? '取消预选' : '预选'}</Button>}
                {Number(record.isCustomerStatus) == 1 ? (
                  <span className="gray">已加客资</span>
                ) : (
                  record.hasPhone ? (
                    <Button type="link" loading={record.loading} onClick={() => addCustomer(record)} className="color-576b95 padding-0">
                      加客资
                    </Button>
                  ) : ''
                )}
              </Space>
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
    </div>
  )
}
